import { Column } from "../../../../components/Core/Tables/interfaces";

export const productTableConfig: Column[] = [
  {
    title: "Producto",
    minWidth: 350,
    parentKey: "parentProduct",
    firstFieldKey: "product",
  },
  {
    title: "Cantidad",
    align: "center",
    minWidth: 147,
    firstFieldKey: "quantity",
  },
  {
    title: "Tipo",
    minWidth: 250,
    firstFieldKey: "discountName",
  },
  {
    title: "Precio base",
    align: "right",
    minWidth: 147,
    firstFieldKey: "base_price",
    firstFieldType: "money",
  },
  {
    title: "Precio de venta",
    align: "right",
    minWidth: 147,
    firstFieldKey: "price",
    firstFieldType: "money",
  },
  {
    title: "Total",
    align: "right",
    minWidth: 147,
    firstFieldKey: "subtotal",
    firstFieldType: "money",
  },
];
